import { useCallback } from "react";
import openhouseAPI from "../services/openhouse";

const useDeleteOpenHouse = () => {
  const deleteOpenHouse = useCallback(async (uuid: string) => {
    openhouseAPI.delete(`/openhouse/${uuid}`).then((res) => console.log(res));
  }, []);

  return deleteOpenHouse;
};

export default useDeleteOpenHouse;
